<template>

  <aside class="cyma-sidebar" :class="{ 'cyma-sidebar--open': menuOpen }">

    <div class="cyma-sidebar__header">

      <router-link to="/" class="cyma-sidebar__brand" exact @click.native="closeMenu">

        <img :src="logoImg" alt="CYMA" class="cyma-sidebar__logo">

        <div class="cyma-sidebar__brand-text">

          <span class="cyma-sidebar__name">{{ $t('brand.fullName') }}</span>

          <span class="cyma-sidebar__tag">{{ $t('brand.tagline') }}</span>

        </div>

      </router-link>

      <button

        type="button"

        class="cyma-sidebar__toggle"

        :aria-expanded="menuOpen ? 'true' : 'false'"

        aria-label="Menu"

        @click="toggleMenu"

      >

        <span></span>

        <span></span>

        <span></span>

      </button>

    </div>



    <div class="cyma-sidebar__backdrop" @click="closeMenu"></div>



    <div class="cyma-sidebar__panel">

      <nav class="cyma-sidebar__nav">

        <router-link to="/" exact class="cyma-sidebar__link" @click.native="closeMenu">

          <span class="cyma-sidebar__link-text">{{ $t('nav.home') }}</span>

        </router-link>

        <router-link to="/about" class="cyma-sidebar__link" @click.native="closeMenu">

          <span class="cyma-sidebar__link-text">{{ $t('nav.about') }}</span>

        </router-link>

        <router-link to="/products" exact class="cyma-sidebar__link" @click.native="closeMenu">

          <span class="cyma-sidebar__link-text">{{ $t('nav.products') }}</span>

        </router-link>

        <router-link to="/oil" class="cyma-sidebar__link cyma-sidebar__link--sub" @click.native="closeMenu">

          <span class="cyma-sidebar__link-text">{{ $t('nav.oil') }}</span>

        </router-link>

        <router-link to="/water" class="cyma-sidebar__link cyma-sidebar__link--sub" @click.native="closeMenu">

          <span class="cyma-sidebar__link-text">{{ $t('nav.water') }}</span>

        </router-link>

        <router-link
          v-for="item in catalogLinks"
          :key="item.slug"
          :to="`/products/${item.slug}`"
          class="cyma-sidebar__link cyma-sidebar__link--sub"
          @click.native="closeMenu"
        >

          <span class="cyma-sidebar__link-text">{{ item.name }}</span>

        </router-link>

        <router-link to="/link" class="cyma-sidebar__link" @click.native="closeMenu">

          <span class="cyma-sidebar__link-text">{{ $t('nav.contact') }}</span>

        </router-link>

        <router-link to="/join" class="cyma-sidebar__link" @click.native="closeMenu">

          <span class="cyma-sidebar__link-text">{{ $t('nav.join') }}</span>

        </router-link>

      </nav>



      <div class="cyma-sidebar__footer">

        <div class="cyma-sidebar__lang">

          <button type="button" :class="{ active: currentLocale === 'zh-CN' }" @click="$setLocale('zh-CN')">{{ zhLabel }}</button>

          <button type="button" :class="{ active: currentLocale === 'en-US' }" @click="$setLocale('en-US')">EN</button>

        </div>

        <div class="cyma-sidebar__contact-mini">

          <a :href="'tel:' + $t('footer.phone')">{{ $t('footer.phone') }}</a><br>

          <a :href="'mailto:' + $t('footer.email')">{{ $t('footer.email') }}</a>

        </div>

      </div>

    </div>

  </aside>

</template>



<script>

import logoImg from '../img/logo.png'
import { catalogSeries } from '../../data/catalog'



export default {

  name: 'CymaSidebar',

  data() {

    return {

      logoImg,

      zhLabel: '\u4E2D\u6587',

      menuOpen: false

    }

  },

  computed: {
    catalogLinks() {
      return catalogSeries.map((item) => ({ slug: item.slug, name: item.name }))
    }
  },

  watch: {

    '$route'() {

      this.closeMenu()

    },

    menuOpen(open) {

      if (typeof document === 'undefined') return

      document.body.style.overflow = open ? 'hidden' : ''

    }

  },

  beforeDestroy() {

    if (typeof document !== 'undefined') {

      document.body.style.overflow = ''

    }

  },

  methods: {

    toggleMenu() {

      this.menuOpen = !this.menuOpen

    },

    closeMenu() {

      this.menuOpen = false

    }

  }

}

</script>


